import { Typography } from '@mui/material';

type UserProfileCardHeaderCustomTitleProps = {
    name: string
}

export function UserProfileCardHeaderCustomTitle({
    name
}: Readonly<UserProfileCardHeaderCustomTitleProps>) {
    return (
        <Typography
            align='left'
            variant='body1'
            color='text.primary'
            sx={{
                fontSize: '16px',
                fontWeight: '600',
                textAlign: 'left'
            }}
        >
            {name}
        </Typography>
    );
}
